import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute, SortOrder } from 'enums';
import { createContext } from 'react';
import { useQuery } from 'react-query';
import { ArchivalAidMetadata, Result } from 'types';
import fetch from 'utils/fetch';

export const AidsListContext = createContext<{
  listResult?: Result<ArchivalAidMetadata>;
  listByOriginatorResult?: Record<string, ArchivalAidMetadata[]>;
}>({ listResult: {}, listByOriginatorResult: {} });

export const useArchivalAidsList = (originatorId?: string) => {
  const response = useQuery([CacheKeys.AID_LIST], () =>
    fetch('/api/' + ApiRoute.ARCHIVAL_AID + '/list', {
      method: 'POST',
      body: JSON.stringify({
        sort: [{ field: 'name', order: 'ASC' as SortOrder }],
        size: -1,
      }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => (await r.json()) as Result<ArchivalAidMetadata>)
  );
  return response;
};

export const useAidsListByOriginator = (id?: string) =>
  useQuery(
    [CacheKeys.AID_LIST_BY_ORIGINATOR, id],
    () =>
      fetch(
        `/api/${ApiRoute.ARCHIVAL_AID}/list-by-originator?originatorId=${id}`
      ).then(
        async (r) => (await r.json()) as Record<string, ArchivalAidMetadata[]>
      ),
    { enabled: !!id }
  );
